/**
 * Root Reducers: Combine the all reducers into a single file
 */
import { combineReducers } from "@reduxjs/toolkit";
/**
 * Imports all app reducers
 */
import AppReducer from "./AppReducer";
import LoginReducer from './LoginReducer';
import ForgotReducer from "./ForgotReducer";
import RegisterReducer from "./RegisterReducer";
import SidebarReducer from './SidebarReducer';
import VenueMenuReducer from "./VenueMenuReducer";
import OrderReducer from "./OrderReducer";
import PosReducer from './PosReducer';
import ModifierReducer from './ModifierReducer';

export default combineReducers({
    global: AppReducer,
    login: LoginReducer,
    forgot: ForgotReducer,
    venueRegister: RegisterReducer,
    sidebar: SidebarReducer,
    venuemenu: VenueMenuReducer,
    order: OrderReducer,
    posmanage: PosReducer,
    modifiers: ModifierReducer,
});
